import { jsxs as a, Fragment as u, jsx as e } from "react/jsx-runtime";
import { useEffect as v, useState as w } from "react";
import { createPortal as S } from "react-dom";
import { motion as x, AnimatePresence as y } from "framer-motion";
import { X as O, ExternalLink as T, LogOut as j, ChevronDown as D, ChevronRight as E } from "lucide-react";
import { cn as d } from "../../lib/utils.js";
import { useInsetSidebar as g } from "../hooks/use-inset-sidebar.js";
import { findActiveSectionKey as U, isRouteActive as A } from "../lib/nav-utils.js";
import { INSET_SIDEBAR_WIDTH as h } from "../types.js";
const k = {
  type: "spring",
  stiffness: 300,
  damping: 30
};
function p({
  section: t,
  currentPath: r,
  onNavigate: n
}) {
  var f;
  const o = t.icon, c = t.trailingIcon, i = U(r, [t]) === t.key, m = c ? /* @__PURE__ */ e(
    c,
    {
      className: d(
        "size-4 flex-shrink-0",
        t.trailingIconClassName ?? "text-muted-foreground"
      ),
      "aria-hidden": "true"
    }
  ) : null;
  return t.external && t.externalUrl ? /* @__PURE__ */ a(
    "a",
    {
      href: t.externalUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      className: d(
        "flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors",
        "text-muted-foreground hover:bg-accent hover:text-accent-foreground"
      ),
      children: [
        /* @__PURE__ */ e(o, { className: "size-4 flex-shrink-0", "aria-hidden": "true" }),
        /* @__PURE__ */ e("span", { className: "flex-1 truncate", children: t.label }),
        m,
        /* @__PURE__ */ e(T, { className: "size-3 opacity-50", "aria-hidden": "true" })
      ]
    }
  ) : t.href ? /* @__PURE__ */ a(
    "a",
    {
      href: t.href,
      onClick: (l) => {
        l.preventDefault(), n(t.href);
      },
      className: d(
        "flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors",
        i ? "bg-primary/10 text-primary font-medium" : "text-muted-foreground hover:bg-accent hover:text-accent-foreground"
      ),
      "aria-current": i ? "page" : void 0,
      children: [
        /* @__PURE__ */ e(o, { className: "size-4 flex-shrink-0", "aria-hidden": "true" }),
        /* @__PURE__ */ e("span", { className: "flex-1 truncate", children: t.label }),
        m
      ]
    }
  ) : (f = t.children) != null && f.length ? /* @__PURE__ */ e(
    M,
    {
      section: t,
      currentPath: r,
      onNavigate: n,
      isActive: i
    }
  ) : null;
}
function M({
  section: t,
  currentPath: r,
  onNavigate: n,
  isActive: o
}) {
  var l;
  const [c, i] = w(o), m = t.icon, f = t.trailingIcon;
  return v(() => {
    o && i(!0);
  }, [o]), /* @__PURE__ */ a("div", { children: [
    /* @__PURE__ */ a(
      "button",
      {
        onClick: () => i((s) => !s),
        className: d(
          "flex w-full items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors",
          o ? "text-primary font-medium" : "text-muted-foreground hover:bg-accent hover:text-accent-foreground"
        ),
        "aria-expanded": c,
        children: [
          /* @__PURE__ */ e(m, { className: "size-4 flex-shrink-0", "aria-hidden": "true" }),
          /* @__PURE__ */ e("span", { className: "flex-1 truncate text-left", children: t.label }),
          f && /* @__PURE__ */ e(
            f,
            {
              className: d(
                "size-4 flex-shrink-0",
                t.trailingIconClassName ?? "text-muted-foreground"
              ),
              "aria-hidden": "true"
            }
          ),
          c ? /* @__PURE__ */ e(D, { className: "size-3.5 opacity-50", "aria-hidden": "true" }) : /* @__PURE__ */ e(E, { className: "size-3.5 opacity-50", "aria-hidden": "true" })
        ]
      }
    ),
    /* @__PURE__ */ e(y, { initial: !1, children: c && /* @__PURE__ */ e(
      x.div,
      {
        initial: { height: 0, opacity: 0 },
        animate: { height: "auto", opacity: 1 },
        exit: { height: 0, opacity: 0 },
        transition: { duration: 0.2, ease: "easeInOut" },
        className: "overflow-hidden",
        role: "group",
        children: /* @__PURE__ */ e("div", { className: "ml-4 border-l border-border pl-2 py-0.5", children: (l = t.children) == null ? void 0 : l.map((s) => {
          const z = s.icon, b = s.trailingIcon, N = A(
            r,
            s.href,
            s.matchPatterns
          );
          return /* @__PURE__ */ a(
            "a",
            {
              href: s.href,
              onClick: (C) => {
                C.preventDefault(), n(s.href);
              },
              className: d(
                "flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors",
                N ? "bg-primary/10 text-primary font-medium" : "text-muted-foreground hover:bg-accent hover:text-accent-foreground"
              ),
              "aria-current": N ? "page" : void 0,
              children: [
                /* @__PURE__ */ e(
                  z,
                  {
                    className: "size-4 flex-shrink-0",
                    "aria-hidden": "true"
                  }
                ),
                /* @__PURE__ */ e("span", { className: "flex-1 truncate", children: s.label }),
                b && /* @__PURE__ */ e(
                  b,
                  {
                    className: d(
                      "size-4 flex-shrink-0",
                      s.trailingIconClassName ?? "text-muted-foreground"
                    ),
                    "aria-hidden": "true"
                  }
                )
              ]
            },
            s.key
          );
        }) })
      }
    ) })
  ] });
}
function R({
  user: t,
  onLogout: r
}) {
  return t ? /* @__PURE__ */ e("div", { className: "p-3 border-t border-border", children: /* @__PURE__ */ a("div", { className: "flex items-center gap-3", children: [
    t.avatarUrl ? /* @__PURE__ */ e(
      "img",
      {
        src: t.avatarUrl,
        alt: `${t.displayName}'s profile picture`,
        className: "size-8 rounded-full object-cover flex-shrink-0"
      }
    ) : /* @__PURE__ */ e(
      "div",
      {
        className: "size-8 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0",
        "aria-hidden": "true",
        children: /* @__PURE__ */ e("span", { className: "text-xs font-semibold text-primary", children: t.avatarInitial || t.displayName.charAt(0) })
      }
    ),
    /* @__PURE__ */ a("div", { className: "flex-1 min-w-0", children: [
      /* @__PURE__ */ e("p", { className: "text-sm font-medium text-foreground truncate", children: t.displayName }),
      t.subtitle && /* @__PURE__ */ e("p", { className: "text-xs text-muted-foreground truncate", children: t.subtitle })
    ] }),
    r && /* @__PURE__ */ e(
      "button",
      {
        onClick: r,
        className: "text-muted-foreground hover:text-foreground hover:bg-accent p-1.5 rounded-md flex-shrink-0 transition-colors",
        "aria-label": "Log out",
        children: /* @__PURE__ */ e(j, { className: "size-4", "aria-hidden": "true" })
      }
    )
  ] }) }) : null;
}
function I({
  sections: t,
  secondaryItems: r,
  categoryGroups: n,
  currentPath: o,
  user: c,
  header: i,
  onNavigate: m,
  onLogout: f
}) {
  return /* @__PURE__ */ a(u, { children: [
    i && /* @__PURE__ */ a("div", { className: "flex items-center gap-2.5 px-4 py-4", children: [
      i.logo && /* @__PURE__ */ e("div", { className: "flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-md", children: i.logo }),
      i.title && /* @__PURE__ */ a("div", { className: "min-w-0", children: [
        /* @__PURE__ */ e("h2", { className: "truncate text-base font-semibold leading-tight tracking-tight text-foreground", children: i.title }),
        i.subtitle && /* @__PURE__ */ e("p", { className: "truncate text-xs leading-tight text-muted-foreground", children: i.subtitle })
      ] })
    ] }),
    /* @__PURE__ */ e("nav", { className: "flex-1 overflow-y-auto overflow-x-hidden px-3 py-2 space-y-1", children: n && n.length > 0 ? /* @__PURE__ */ e("div", { className: "space-y-4", children: n.map((l) => /* @__PURE__ */ a("div", { className: "space-y-1", children: [
      /* @__PURE__ */ e("p", { className: "px-3 py-1.5 text-xs font-semibold text-muted-foreground uppercase tracking-wider truncate", children: l.label }),
      /* @__PURE__ */ e("div", { className: "space-y-1", children: l.sections.map((s) => /* @__PURE__ */ e(
        p,
        {
          section: s,
          currentPath: o,
          onNavigate: m
        },
        s.key
      )) })
    ] }, l.label)) }) : /* @__PURE__ */ a(u, { children: [
      t.map((l) => /* @__PURE__ */ e(
        p,
        {
          section: l,
          currentPath: o,
          onNavigate: m
        },
        l.key
      )),
      r && r.length > 0 && /* @__PURE__ */ a(u, { children: [
        /* @__PURE__ */ e("div", { className: "my-3 border-t border-border" }),
        r.map((l) => /* @__PURE__ */ e(
          p,
          {
            section: l,
            currentPath: o,
            onNavigate: m
          },
          l.key
        ))
      ] })
    ] }) }),
    /* @__PURE__ */ e(R, { user: c, onLogout: f })
  ] });
}
function _(t) {
  const { isOpen: r } = g(), n = t["data-testid"];
  return /* @__PURE__ */ e(
    x.aside,
    {
      animate: { width: r ? h : 0 },
      transition: k,
      className: d(
        "hidden md:flex flex-col overflow-hidden rounded-xl bg-card border border-border flex-shrink-0",
        t.className
      ),
      "aria-label": "Main navigation",
      "data-testid": n,
      children: r && /* @__PURE__ */ e(I, { ...t })
    }
  );
}
function L(t) {
  const { isOpen: r, setIsOpen: n } = g();
  return v(() => {
    n(!1);
  }, [t.currentPath, n]), S(
    /* @__PURE__ */ e(y, { children: r && /* @__PURE__ */ a(u, { children: [
      /* @__PURE__ */ e(
        x.div,
        {
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          exit: { opacity: 0 },
          transition: { duration: 0.2 },
          className: "fixed inset-0 z-50 bg-black/50",
          onClick: () => n(!1),
          "aria-hidden": "true"
        }
      ),
      /* @__PURE__ */ a(
        x.aside,
        {
          initial: { x: -h },
          animate: { x: 0 },
          exit: { x: -h },
          transition: k,
          className: d(
            "fixed left-0 top-0 bottom-0 z-50 flex flex-col bg-card shadow-xl",
            t.className
          ),
          style: { width: h },
          role: "dialog",
          "aria-label": "Navigation menu",
          children: [
            /* @__PURE__ */ a("div", { className: "flex items-center justify-between px-4 py-3 border-b border-border", children: [
              /* @__PURE__ */ e("span", { className: "text-sm font-semibold text-foreground", children: "Menu" }),
              /* @__PURE__ */ e(
                "button",
                {
                  onClick: () => n(!1),
                  className: "p-1.5 rounded-md text-muted-foreground hover:bg-accent hover:text-accent-foreground transition-colors",
                  "aria-label": "Close navigation menu",
                  children: /* @__PURE__ */ e(O, { className: "size-5", "aria-hidden": "true" })
                }
              )
            ] }),
            /* @__PURE__ */ e(I, { ...t })
          ]
        }
      )
    ] }) }),
    document.body
  );
}
function J(t) {
  const { isMobile: r } = g();
  return /* @__PURE__ */ a(u, { children: [
    !r && /* @__PURE__ */ e(_, { ...t }),
    r && /* @__PURE__ */ e(L, { ...t })
  ] });
}
export {
  J as InsetSidebar
};
